const isDevMode = process.env.NODE_ENV === 'development';

export const model = isDevMode 
? {
    cardNo: {
      block1: '5520',
      block2: '4649',
      block3: '9970',
      block4: '0105',
    },
    deadlineAndCCV: {
      yy: '20',
      mm: '11',
      ccv: '512'
    }
  }
: {
    cardNo: {
      block1: '',
      block2: '',
      block3: '',
      block4: '',
    },
    deadlineAndCCV: {
      yy: '',
      mm: '',
      ccv: ''
    }
  };

const creditCardValidator = (rule, value, callback) => {
  const cardNo = Object.values(value).reduce((acc, block) => acc + block, '');
  if (cardNo.length !== 16) return callback(new Error('請輸入正確信用卡號格式'));
  const lastNum = parseInt(cardNo.slice(-1), 10);
  const validateFormat = cardNo
    .substr(0, cardNo.length - 1)
    .split('')
    .reverse();
  const sum = validateFormat.reduce((acc, num, index) => {
    const val = parseInt(num, 10);
    if ((index + 1) % 2 === 0) {
      acc += val;
      return acc;
    }
    const multiplyWeights = val * 2 >= 10
      ? (val * 2) - 9
      : val * 2;
    acc += multiplyWeights;
    return acc;
  }, 0);
  if ((sum + lastNum) % 10 !== 0) return callback(new Error('請輸入正確卡號'));
  callback();
};

export const rules = {
  cardNo: { trigger: 'validate', validator: creditCardValidator },
  deadlineAndCCV: {
    type: 'object',
    fields: {
      yy: { type: 'string', required: true, message: '請選擇有效年份' },
      mm: { type: 'string', required: true, message: '請選擇有效月份' },
      ccv: { type: 'string', required: true, message: '請輸入安全碼' }
    },
    trigger: 'validate'
  },
};
